import { Subscription } from 'rxjs';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ErrorHandlingService } from 'src/app/shared/error-handling/error-handling.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { PasswordValidators } from 'src/app/shared/validators/password.validators';
import { UserService } from 'src/app/view/users/services/user.service';
import { RWDService } from '../../services/rwd.service';

@Component({
  selector: 'app-action-handler',
  templateUrl: './action-handler.component.html',
  styleUrls: ['./action-handler.component.scss']
})
export class ActionHandlerComponent implements OnInit, OnDestroy {
  public form: FormGroup;
  public done = false;

  public mode: 'verifyEmail' | 'resetPassword' | 'error';
  public error = 'request';

  private oobCode: string;

  private subscription$ = new Subscription();

  MIN_LENGTH = PasswordValidators.MIN_LENGTH;

  constructor(
    public rwdService: RWDService,
    private fb: FormBuilder,
    private authService: AuthService,
    private route: ActivatedRoute,
    private userService: UserService,
    private errorHandlingService: ErrorHandlingService
  ) {
    this.mode = this.route.snapshot.queryParams['mode'];
    this.oobCode = this.route.snapshot.queryParams['oobCode'];

    switch (this.mode) {
      case 'verifyEmail':
        this.confirmMobileUser();
        break;
      case 'resetPassword':
        break;
      default:
        this.mode = 'error';
        break;
    }

    this.authService.verifyCode(this.oobCode).catch((error) => {
      this.mode = 'error';

      switch (error.code) {
        case 'auth/expired-action-code':
          this.error = 'oob.expired';
          break;
        case 'auth/invalid-action-code':
          this.error = 'oob.invalid';
          break;
      }
    });

    this.form = this.fb.group({
      password: [null, [Validators.required, PasswordValidators.policy]],
      confirm: [null, [Validators.required, PasswordValidators.confirm('password')]]
    });
  }

  ngOnInit(): void {
    this.subscription$.add(
      this.form.controls.password.valueChanges.subscribe(() => this.form.controls.confirm.updateValueAndValidity())
    );
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

  public async setPassword(): Promise<void> {
    if (this.form.valid) {
      try {
        // * oobCode is one-use code, but checking data is not considered an action that uses oobCode
        const email = await this.authService.getEmailFromOob(this.oobCode);
        await this.authService.confirmPasswordReset(this.oobCode, this.form.value.password);
        if (email) {
          const updatePasswordDate = async (user: any) => {
            if (user) await this.userService.setPasswordDate(user.user.uid);
            // ? log out after update password date to clear session
            this.authService.logOut();
          };
          // ? reauthenticate user to update password date
          await this.authService.logIn(email, this.form.value.password, updatePasswordDate);
        }
        this.done = true;
      } catch (e) {
        this.mode = 'error';
        this.errorHandlingService.showSilentWarning(e);
      }
    } else {
      this.form.markAllAsTouched();
    }
  }

  private confirmMobileUser() {
    this.authService
      .verifyEmail(this.oobCode)
      .then(() => (this.done = true))
      .catch((e) => {
        this.mode = 'error';
        this.errorHandlingService.showSilentWarning(e);
      });
  }
}
